import DeleteGenericModal from "../../modals/DeleteGenericModal";
import ReactTable from "../../util/ReactTable";
import AsyncBlock from "../../components/forms/AsyncBlock";
import PageTitle from "../../components/layout/PageTitle";
import PageSection from "../../components/layout/PageSection";
import Button from "../../components/forms/Button";
import PageContainerFull from "../../components/layout/PageContainerFull";
import {useCallback, useMemo} from "react";
import {FlexLayout} from "../../components/flex/Flex";
import useDeleteModal from "../../modals/useDeleteModal";
import axios from "axios";
import useFetch2 from "../../hooks/useFetch2";
import {Apis} from "../../util/data";
import {useNavigate} from "react-router-dom";
import * as React from "react";

const CategoriaList = () => {

  const navigate = useNavigate()
  const {loading, data, fetchData, error} = useFetch2(Apis.PROD + '/categoria-producto', []);

  const deleteElement = id => axios.delete(Apis.PROD + '/categoria-producto/' + id)

  const {
    wrapper: wrapper1,
    openDeleteModal
  } = useDeleteModal({
    text: '¿Desea eliminar esta categoria?',
    action: deleteElement,
    onRefresh: fetchData
  })

  function addCategoria() {
    navigate('/categoria/new')
  }

  function editCategoria(item) {
    navigate('/categoria/edit/' + item.id)
  }

  const actionsValue = useCallback(cell =>
      <FlexLayout justifyContent='center'>
        <Button size='xs' variant='light' onClick={() => editCategoria(cell.row.original)}>Editar</Button>
        <Button size='xs' variant='danger' onClick={() => openDeleteModal(cell.row.original.id)}>Eliminar</Button>
      </FlexLayout>
    // eslint-disable-next-line react-hooks/exhaustive-deps
    , []);

  const columns = useMemo(
    () => [
      {
        header: 'Categoria',
        accessorKey: 'categoria'
      },
      {
        header: 'Acciones',
        accessorKey: 'id',
        meta: {
          headerClassName: 'text-center', // class para la cabecera
          columnClassName: 'text-center', // class para la columna
        },
        enableSorting: false, // para deshabilitar el sort
        cell: actionsValue
      }
    ]
    // eslint-disable-next-line react-hooks/exhaustive-deps
    , [data]
  )

  return (
    <PageContainerFull>

      <PageSection>
        <PageTitle title={'Categorias de producto'}/>

        <AsyncBlock loading={loading} error={error}>
          <ReactTable
            columns={columns}
            data={data || []}
            customSearch
            filterAdd={() => addCategoria()}
            noData='No existen categorias'
            pageSize={20}
          />
        </AsyncBlock>
      </PageSection>
      <DeleteGenericModal {...wrapper1} />
    </PageContainerFull>
  )
}

export default CategoriaList
